import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject, Subscriber } from 'rxjs';
import { Router } from '@angular/router';
import { ServerService } from '../firebase/server.service';


@Injectable({
  providedIn: 'root'
})

export class DashboardHomeService {
  public observer: Subscriber<{}>;

  constructor(private router: Router, private server: ServerService) {
  }

  public getAccountsCount(data: any): Observable<object> {
    var subject = new Subject<object>();
    this.server.get('/accounts/stats/counts', data

    ).subscribe((response: any) => {
      console.log(response);
      subject.next(response);
    }, error => {
      console.log(error);
      subject.next(error.status);
    });
    return subject.asObservable();
  }

  public getDealsCount(data: any): Observable<object> {
    var subject = new Subject<object>();
    this.server.get('/deals/stats/counts', data

    ).subscribe((response: any) => {
      console.log(response);
      subject.next(response);
    }, error => {
      console.log(error);
      subject.next(error.status);
    });
    return subject.asObservable();
  }

  public getCashToStorks(data: any): Observable<object> {
    var subject = new Subject<object>();
    this.server.get('/deals/stats/payments', data

    ).subscribe((response: any) => {
      console.log(response);
      subject.next(response);
    }, error => {
      console.log(error);
      subject.next(error.status);
    });
    return subject.asObservable();
  }
}
